import { MouseEventHandler } from 'react';
import styled from 'styled-components';

const Circle = styled.div<{ $size: number }>`
  width: ${props => props.$size}px;
  height: ${props => props.$size}px;
  border-radius: 50%;
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => props.theme.brand.gradBrand};
  color: #fff;
  font-weight: 700;
  font-size: ${props => Math.round(props.$size * 0.32)}px;
  line-height: 1;
  text-transform: uppercase;
  user-select: none;
`;

export const getInitials = (name?: string): string => {
  if (!name) return '';
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '';
  if (words.length > 1) return (words[0][0] ?? '') + (words[words.length - 1][0] ?? '');

  const word = words[0];
  const upper = word.slice(1).match(/[A-Z]/);
  return upper ? word[0] + upper[0] : word.slice(0, 2);
};

type Props = {
  name?: string;
  size?: number;
  onClick?: MouseEventHandler<HTMLDivElement>;
  className?: string;
};

const BrandAvatarFallback: React.FC<Props> = ({ name, size = 34, onClick, className }) => (
  <Circle $size={size} onClick={onClick} className={className}>
    {getInitials(name)}
  </Circle>
);

export default BrandAvatarFallback;
